var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-expand"},[_c('div',{staticClass:"content1"},[_c('h2',[_vm._v("Expand into"),_c('br'),_vm._v("own EC website")]),_c('p',{staticClass:"sub-title"},[_vm._v("自社ECサイトへの展開による事業拡大")]),_c('p',{staticClass:"wrap"},[_vm._v(" ショッピングモールから立ち上げを行った場合、モールへのアクセスデータや販売データを解析し、活用して、自社ECサイトの展開を効果的・効率的に行います。これによって販売の拡大を実現します。 ")])])])
}]

export { render, staticRenderFns }